import calculator from '@/calculator/calculator'
import { Course } from '@/data/models'
import { useCalculatorStore } from '@/store/calculatorStore'
import type { CalculatorStore } from '@/store/calculatorStore'

export function calculateResultsFromState(state: CalculatorStore) {
  const includedCourses = state.courses.filter((course) => course.included)
  const tjueTreFemCourses = includedCourses.filter(
    (course) => course.is235course
  )

  const improved = calculator(
    includedCourses,
    state.userDetails,
    state.extraPoints,
    state.inputDiploma,
    true
  )
  const unimproved = calculator(
    includedCourses,
    state.userDetails,
    state.extraPoints,
    state.inputDiploma,
    false
  )
  const tjueTreFemImproved = calculator(
    tjueTreFemCourses,
    state.userDetails,
    state.extraPoints,
    '235',
    true
  )
  const tjueTreFemUnimproved = calculator(
    tjueTreFemCourses,
    state.userDetails,
    state.extraPoints,
    '235',
    false
  )

  improved.total_improved = improved.total_normal - unimproved.total_normal
  tjueTreFemImproved.total_improved =
    tjueTreFemImproved.total_normal - tjueTreFemUnimproved.total_normal

  return { improved, unimproved, tjueTreFemImproved, tjueTreFemUnimproved }
}

export function useCalculateResults() {
  const state = useCalculatorStore((state) => state)
  return calculateResultsFromState(state)
}

export function isImprovementSet(course: Course) {
  if (!course.improved) {
    return false
  }
  if (course.hasTwoExams && !course.improved2) {
    return false
  }
  return true
}

export function useCalculateCourseImprovement(courseId: Course['id']) {
  const { improved, tjueTreFemImproved } = useCalculateResults()
  const show235 = useCalculatorStore((state) => state.show235)
  const courses = useCalculatorStore((state) => state.courses)
  const coursesToCalculate = show235
    ? courses.filter((course) => course.included && course.is235course)
    : courses.filter((course) => course.included)

  const course = coursesToCalculate.find((course) => course.id === courseId)
  if (!course) return 0

  if (!isImprovementSet(course)) {
    return 0
  }

  const courseWithoutImprovements = {
    ...course,
    improved: 0,
    improved2: 0,
  }

  const coursesWithoutImprovements = coursesToCalculate.map((c) =>
    c.id === courseId ? courseWithoutImprovements : c
  )

  const resultsWithoutImprovements = calculator(
    coursesWithoutImprovements,
    useCalculatorStore.getState().userDetails,
    useCalculatorStore.getState().extraPoints,
    show235 ? '235' : useCalculatorStore.getState().inputDiploma,
    true
  )

  const currentPoints = show235 ? tjueTreFemImproved : improved
  const pointsWithoutImprovements = resultsWithoutImprovements

  return currentPoints.total_normal - pointsWithoutImprovements.total_normal
}
